import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
// Constants
import { pathHomePage, primaryColor } from "../../../config/constants";
// Components
import { QuestionnairesContainer, QuestionnaireLink } from "./styles";

const QuestionnairesMenu = () => {
  const { clinicianToken, patientId, software } = useParams();
  const currentPath = window.location.href;
  const [t] = useTranslation("global");

  return (
    <QuestionnairesContainer>
      <QuestionnaireLink
        to={`${pathHomePage}/commitment-questions/${clinicianToken}/${patientId}/${software}`}
        border="2px solid #808080"
        fontWeight={currentPath.includes("commitment-questions") ? "bold" : ""}
        color={currentPath.includes("commitment-questions") ? "#808080" : primaryColor}
      >
        {t("questionnairesMenu_commitmentQuestions")}
      </QuestionnaireLink>
      <QuestionnaireLink
        to={`${pathHomePage}/emotional-questions/${clinicianToken}/${patientId}/${software}`}
        fontWeight={currentPath.includes("emotional-questions") ? "bold" : ""}
        color={currentPath.includes("emotional-questions") ? "#808080" : primaryColor}
      >
        {t("questionnairesMenu_emotionalQuestions")}
      </QuestionnaireLink>
    </QuestionnairesContainer>
  );
};

export default QuestionnairesMenu;
